export const TABLE_CELL_NOT_CLICKABLE_CLASS = 'not-clickable'
